export default __webpack_public_path__ + "static/media/inhouseProducts.7e1cd69e.jpg";